export enum InvoiceFormTypeEnum {
  NEW_CERTIFICATE = 'NEW_CERTIFICATE',
  NEW_TRADE = 'NEW_TRADE'
}
